import React, { useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import AuthNavbar from "utils/Navbars/AuthNavbarAdvance.js";
import { Device, DeviceContext } from 'utils/Device';
import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";
import Hidden from "@material-ui/core/Hidden";
import { FormControl, Grid } from "@material-ui/core";

import { useCookies } from 'react-cookie';
import { useHistory } from "react-router-dom";
import { Box, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, Paper } from '@mui/material';

import QuotesDMA from "components/QuotesDMA";
import PoliciesDMA from "components/PoliciesDMA";

import dmaState from "assets/img/NewJersey_DMA.jpg";

const useStyles = makeStyles(styles);

const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);

    React.useEffect(() => {
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });
    return matches;
};

var obj;
export default function Pages(props) {
    const [cookies, setCookie] = useCookies(['auth']);
    //Helper functions
    function isNotNull(data) {
        if (data == null || data == "") {
            return false;
        } else {
            return true;
        }
    }

    //Event Handlers
    const changeStartDate = (date) => {
        setStartDate((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    };

    const changeEndDate = (date) => {
        setEndDate((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    };

    const changeCall = () => {
        setCall("true");
    };
    const changeGroupDateBy = (selected) => {
        setGroupDateBy(selected);
    };
    //Events End

    //State Variables 
    var date = new Date();
    // var startdate = date.setDate(date.getDate() - 32);
    //startDate = Date.
    const [startDate, setStartDate] = React.useState((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    const [endDate, setEndDate] = React.useState((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    const [groupDateBy, setGroupDateBy] = React.useState("Day");
    const [call, setCall] = React.useState(false);


    const device = Device();
    const { ...rest } = props;
    // ref for the wrapper div
    const wrapper = React.createRef();
    // styles
    const classes = useStyles();

    //When user refresh page or submit new dates, get all the data
    React.useEffect(() => {
        if (call == "true" || call == null) {
            //setQuoteTotalPip(null);
            //Refresh();
        }


        return () => {
            //End
            setCall("false");

        }
    }, [call]);


    //Utility functions
    const getActiveRoute = routes => {
        let activeRoute = "Default Brand Text";
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                let collapseActiveRoute = getActiveRoute(routes[i].views);
                if (collapseActiveRoute !== activeRoute) {
                    return collapseActiveRoute;
                }
            } else {
                if (
                    window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
                ) {
                    return routes[i].name;
                }
            }
        }
        return activeRoute;
    }
    const history = useHistory();
    if (cookies.pass == undefined) {
        history.push('/');
    }
    //Utility functions End

    const [imageLoaded, setImageLoaded] = React.useState(false);

    return (
        <DeviceContext.Provider value={device}>
            <div>
                <div className={classes.wrapper} ref={wrapper}>
                    <AuthNavbar onChangeCall={changeCall} onChangeStartDate={changeStartDate} onChangeEndDate={changeEndDate} onChangeGroupDateBy={changeGroupDateBy} startDate={startDate} endDate={endDate} groupDateBy={groupDateBy} state="NJ" Text={"New Jersey Dashboard"} {...rest} />
                    <div>
                        <Grid container>
                            <Grid item xs={12} sm={12}>
                                <Hidden smDown>
                                    <h1 style={{ textAlign: "center", fontWeight: "bold", color: "rgb(29, 76, 128)" }} >NEW JERSEY DESIGNATED MARKETING AREAS</h1>
                                </Hidden>
                                <Hidden mdUp>
                                    <h3 style={{ textAlign: "center", fontWeight: "bold", color: "rgb(29, 76, 128)" }} >NEW JERSEY DESIGNATED MARKETING AREAS</h3>
                                </Hidden>
                            </Grid>
                            <Hidden mdDown>
                                <Grid item xs={12} lg={3} ></Grid>
                            </Hidden>
                            <Grid item xs={12} sm={12} md={11} lg={5} style={{ textAlign: "center" }}>
                                <Box
                                    sx={{
                                        position: 'relative',
                                        width: '100%',
                                        maxWidth: 600,
                                        margin: '0 auto',
                                        display: 'flex',
                                        justifyContent: 'flex-end'
                                    }}
                                >
                                    <img
                                        src={dmaState}
                                        alt="New Jersey State"
                                        style={{ width: '50%', display: 'block' }}
                                        onLoad={() => setImageLoaded(true)}
                                    />
                                    {imageLoaded && <DMAPopulationTable isMobile={device.isMobile} />}
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <QuotesDMA
                                    startDate={startDate}
                                    endDate={endDate}
                                    call={call}
                                    groupBy={groupDateBy}
                                    state={'NJ'}
                                />
                            </Grid>
                            <PoliciesDMA
                                startDate={startDate}
                                endDate={endDate}
                                call={call}
                                groupBy={groupDateBy}
                                state={'NJ'}
                            />
                        </Grid>
                    </div>
                </div>
            </div>
        </DeviceContext.Provider>
    );
}

const DMAPopulationTable = (props) => {
    return (
        <TableContainer
            component={Paper}
            sx={{
                position: 'absolute',
                bottom: props.isMobile ? '45%' : 250, // Distance from the bottom edge
                left: props.isMobile ? '3.5%' : 0, // Distance from the left edge
                width: props.isMobile ? '55%' : 280,
                maxWidth: 280,
                overflowX: 'hidden',
                boxShadow: 3, // Adds elevation depth over the image
                '& .MuiTableCell-root': {
                    borderColor: '#e0e0e0', // Clean light border lines
                    padding: props.isMobile ? 'calc(3px + 0.25vw)' : '5px', // Added slightly more horizontal padding
                    fontSize: props.isMobile ? 'calc(10px + 0.4vw)' : '1em',
                },
                '& th.MuiTableCell-head': {
                    backgroundColor: (theme) => theme.palette.common.black,
                    color: (theme) => theme.palette.common.white,
                    fontWeight: 'bold',
                },
                '& tbody tr': {
                    backgroundColor: '#ffffff',
                    '& .MuiTableCell-body': {
                        color: 'rgba(0, 0, 0, 0.87)' // High contrast black body text
                    }
                },
                '& tbody tr:nth-of-type(odd)': {
                    backgroundColor: '#f5f5f5', // Soft, standard light gray theme
                },
                '& tbody tr:last-child td': {
                    borderBottom: '1px solid #e0e0e0' // Matches bottom edge of your image
                }
            }}
        >
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>DMA</TableCell>
                        <TableCell align="center">Population</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>New York-North Jersey</TableCell>
                        <TableCell align="right">7,223,575</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Philadelphia-South Jersey</TableCell>
                        <TableCell align="right">2,324,640</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell style={{ fontSize: props.isMobile ? '0.7em' : '0.7em', backgroundColor: '#ffffff' }}>Data as of July 2025</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};
